import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Handle, NodeProps, Position } from "@xyflow/react";

import styles from "./CompanyOrgStructure.module.css";
import { OrgStructureNodeData } from "./orgStructureToFlow";

function truncate(text: string, maxLength: number): string {
    const trimmed = text.trim();
    if (!trimmed) {
        return "";
    }
    if (trimmed.length <= maxLength) {
        return trimmed;
    }
    return `${trimmed.slice(0, maxLength - 1)}…`;
}

function kindClass(kind: OrgStructureNodeData["kind"]): string {
    switch (kind) {
        case "leadership":
            return styles.nodeLeadership;
        case "division":
            return styles.nodeDivision;
        case "unit":
            return styles.nodeUnit;
        case "team":
            return styles.nodeTeam;
        case "key_persons":
            return styles.nodeKeyPersons;
        default:
            return styles.nodeLeadership;
    }
}

function OrgStructureNodeComponent({ data }: NodeProps) {
    const { t } = useTranslation();
    const nodeData = data as OrgStructureNodeData;
    const title = truncate(nodeData.title, 80) || t(`settingsPage.company.orgStructure.kinds.${nodeData.kind}`);
    const preview =
        nodeData.peopleCount > 0
            ? nodeData.peopleCount === 1
              ? nodeData.firstPersonName
              : t("settingsPage.company.orgStructure.nodePeopleCount", { count: nodeData.peopleCount })
            : truncate(nodeData.description, 60) || "…";

    return (
        <div
            className={`${styles.orgNode} ${kindClass(nodeData.kind)} ${nodeData.selected ? styles.nodeSelected : ""}`}
        >
            <Handle type="target" position={Position.Top} className={styles.nodeHandle} />
            <div className={styles.nodeKindLabel}>
                {t(`settingsPage.company.orgStructure.kinds.${nodeData.kind}`)}
            </div>
            <div className={styles.nodeTitle}>{title}</div>
            <div className={styles.nodePreview}>{preview}</div>
            <Handle type="source" position={Position.Bottom} className={styles.nodeHandle} />
        </div>
    );
}

export const OrgStructureNode = memo(OrgStructureNodeComponent);
